import { defineStore } from 'pinia'
import { legalLinks } from '@/helpers/userData.js'

export const useI18nStore = defineStore('i18n', {
	state: () => ({
		language: null,
	}),

	getters: {
		getLanguage(state) {
			return state.language
		},
		getLegalLinks(state) {
			return legalLinks(state.language)
		},
	},

	actions: {
		setLanguage(language) {
			this.language = language
		},
	},
})
